module.exports = __webpack_public_path__ + "static/media/dolly-empty.44fbfab7.svg";